import { Router } from '@angular/router';
import { Observable, of, from } from 'rxjs';
import { tap, catchError, map, switchMap } from 'rxjs/operators';

import { ApiService } from '@/api';
import { AuthService } from '@/auth/services';
import { User } from '@/interfaces';
import {
    CryptoService,
    UIService
} from '@/service';


export function restoreTabs(ui: UIService): () => Promise<void> {
    return () => ui.restoreExpandedTabs().then(() => ui.markInitialized('tabs'));
}

export function restoreFlags(ui: UIService): () => Promise<void> {
    return () => ui.restoreFeatureFlags();
}

export function fetchFlags(ui: UIService, api: ApiService, router: Router): () => Observable<string[]> {
    return () =>
        api.get<string[]>('/flags').pipe(
            map(r => r.data),
            tap(flags => {
                ui.featureFlags = flags;

                if (ui.isEnabled('Maintenance.enabled')) {
                    router.navigateByUrl('/maintenance');
                }

                ui.markInitialized('flags');
            })
        );
}

export function fetchUser(
    ui: UIService,
    auth: AuthService,
    crypto: CryptoService
): () => Observable<User | null> {

    return () =>
        of(null).pipe(
            switchMap(() => from(crypto.generateRsaKeyPair())),
            switchMap(() => {
                if (!localStorage.getItem('access_token')) {
                    ui.markInitialized('user');
                    return of(null);
                }

                return auth.me().pipe(
                    catchError(err => {
                        if (err.status === 401) {
                            auth.logout('session');
                        }
                        ui.markInitialized('user');
                        return of(null);
                    }),
                    tap(user => {
                        auth.user = user;
                        ui.markInitialized('user');
                    })
                );
            })
        );
}
